import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

const SidebarLink = ({ name, icon, dashboardKey, isActive, onClick, count }) => (
    <div
        onClick={() => onClick(dashboardKey)}
        style={{
            display: 'flex',
            alignItems: 'center',
            padding: '14px 18px',
            cursor: 'pointer',
            borderRadius: '12px',
            marginBottom: '10px',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            backgroundColor: isActive ? '#1e90ff' : 'transparent',
            color: isActive ? '#fff' : '#64748b',
            fontWeight: isActive ? '600' : '500',
            boxShadow: isActive ? '0 4px 12px rgba(30, 144, 255, 0.35)' : 'none',
        }}
        onMouseOver={e => !isActive && (e.currentTarget.style.backgroundColor = '#f1f5f9')}
        onMouseOut={e => !isActive && (e.currentTarget.style.backgroundColor = 'transparent')}
    >
        <span style={{ marginRight: '14px', fontSize: '1.2rem' }}>
            {icon}
        </span>
        <span style={{ fontSize: '0.95rem', letterSpacing: '0.3px' }}>{name}</span>
        
        {count > 0 && (
            <span style={{ 
                marginLeft: 'auto', 
                backgroundColor: isActive ? '#fff' : '#ef4444', 
                color: isActive ? '#1e90ff' : '#fff', 
                borderRadius: '50px', 
                padding: '2px 10px', 
                fontSize: '0.75rem',
                fontWeight: '700'
            }}>
                {count}
            </span>
        )}
    </div>
);

export default function Sidebar({ activeDashboard, handleNavigate, unreadChatCount }) {
    const { user } = useAuth();
    const { t } = useTranslation();
    
    const userRole = user?.role || 'staff'; 
    const isManager = userRole === 'manager' || userRole === 'admin';

    const navItems = [
        { key: 'reception', name: t('sidebar.reception'), icon: '🏢' },
        { key: 'housekeeping', name: t('sidebar.housekeeping'), icon: '🧹' },
        { key: 'inventory', name: t('sidebar.inventory'), icon: '📦' },
        { key: 'settings', name: t('sidebar.settings'), icon: '⚙️' },
        { key: 'admin', name: t('sidebar.admin_panel'), icon: '🛡️', restricted: !isManager },
    ];
    
    return (
        <aside style={{
            width: '280px',
            position: 'fixed',
            top: '0',
            left: '0',
            bottom: '0',
            backgroundColor: '#ffffff',
            padding: '30px 20px',
            borderRight: '1px solid #f1f5f9',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1200, // Stays above navbar shadow
            boxSizing: 'border-box'
        }}>
            {/* BRANDING SECTION */}
            <div style={{ padding: '0 10px 40px 10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e90ff 0%, #0070f3 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '12px',
                        fontWeight: '800',
                        fontSize: '22px',
                        boxShadow: '0 4px 10px rgba(30, 144, 255, 0.3)'
                    }}>É</div>
                    <div>
                        <div style={{ fontSize: '18px', fontWeight: '800', color: '#1e293b', lineHeight: '1' }}>ÉPICURYS</div>
                        <div style={{ fontSize: '11px', fontWeight: '600', color: '#94a3b8', marginTop: '4px', letterSpacing: '1px' }}>MANAGEMENT</div>
                    </div>
                </div>
            </div>

            <nav style={{ flex: 1 }}>
                {navItems.map(item => {
                    if (item.restricted) return null;
                    return (
                        <SidebarLink
                            key={item.key}
                            name={item.name}
                            icon={item.icon}
                            dashboardKey={item.key}
                            isActive={activeDashboard === item.key}
                            onClick={handleNavigate}
                            count={item.key === 'reception' ? unreadChatCount : 0}
                        />
                    );
                })}
            </nav>

            {/* USER PROFILE CARD */}
            <div style={{ 
                background: '#f8fafc', 
                borderRadius: '16px', 
                padding: '15px', 
                marginTop: 'auto',
                border: '1px solid #f1f5f9'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ 
                        width: '35px', 
                        height: '35px', 
                        borderRadius: '10px', 
                        backgroundColor: '#e2e8f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px'
                    }}>👤</div>
                    <div style={{ overflow: 'hidden' }}>
                        <div style={{ fontSize: '0.85rem', fontWeight: '700', color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {user?.email?.split('@')[0]}
                        </div>
                        <div style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'capitalize' }}>
                             {userRole} Mode
                        </div>
                    </div>
                </div>
            </div>
        </aside>
    );
}